<!--
	@name app-privacy
	@description privacy page
	@date 2020/05/20
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div :component="$options.name">
		<div class="py-15 hero">
			<v-container fill-height>
				<div class="text-h4 text-md-h3 text-lg-h2 text-md-h3 text-lg-h2 text-center text-sm-left white--text font-weight-bold pl-md-10" style="max-width: 650px;">
					Privacy Policy
				</div>
			</v-container>
		</div>

		<v-container v-if="site" class="py-8" :class="{ 'py-15': $vuetify.breakpoint.mdAndUp }" style="max-width: 1050px;">
			<app-common-privacy />
		</v-container>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import AppCommonPrivacy from '@/component/app/common/privacy';

	export default {
		name: 'app-privacy',

		components: {
            AppCommonPrivacy
        },

		data() {
			return {
                hero: `${process.env.VUE_APP_S3_AIR_ASSETS_URL}/manager_documents/9d61d51d-45ee-4525-8464-f534768af0de.png`
            };
		},

		computed: { ...mapState('CmsSite', ['site']) },

		mounted() {
        },

		methods: {}
	};
</script>

<style lang="scss" scoped>
    .hero {
        position: relative;
        overflow: hidden;
        z-index: 1;
        height: 300px;
        border-bottom: 20px solid rgb(30, 176, 225);
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: cover;
		background-image: url($VUE_APP_S3_AIR_ASSETS_URL + '/manager_documents/9d61d51d-45ee-4525-8464-f534768af0de.png');
    }

    @media #{map-get($display-breakpoints, 'md-and-up')} {
        .hero {
            height: 500px;
        }
    }
</style>